import { useStaticQuery, graphql } from 'gatsby'

export const getOtherResourceHeroData = () => {
  const { allStrapiCommonHero } = useStaticQuery(otherResourceHeroDataQuery)
  let otherResourceHeroData = allStrapiCommonHero.nodes[0].Heros.filter(
    value => Object.keys(value).length !== 0
  )
  return otherResourceHeroData[0]
}

const otherResourceHeroDataQuery = graphql`
  query {
    allStrapiCommonHero {
      nodes {
        Heros {
          ... on STRAPI__COMPONENT_SHARED_OTHER_RESOURCES_HERO {
            id
            button {
              id
              name
              url
            }
            description {
              data {
                description
              }
            }
            title
          }
        }
      }
    }
  }
`
